import { G as Grid, d as defineCustomElement$1 } from './grid.js';

const TtGrid = Grid;
const defineCustomElement = defineCustomElement$1;

export { TtGrid, defineCustomElement };
